<template>
    <b-overlay :show="loading" rounded="sm" >
    <div class="container-scroller login-page" id="login-page">
        <b-container fluid class="page-body-wrapper full-page-wrapper">
            <div class="content-wrapper d-flex align-items-center auth">
                <b-row class="flex-grow">
                    <b-col lg="7" md="12" sm="12" class="mx-auto">
                        <b-row class="auth-form-light text-left">
                            <b-col class="col-lg-6 left-side col-md-12 col-sm-12">
                                <div class="brand-logo text-center">
                                    <img src="@/assets/images/ams_new_logo.png" />
                                </div>
                                <h4>{{ $translate('sign_in_note') }}</h4>
                                <b-alert variant="danger" :show="!!signInError">{{ signInError }}</b-alert>
                                <b-form @submit="e => login(e)" class="pt-3">
                                    <b-form-group>
                                        <b-form-input type="email" class="form-control form-control-sm"
                                            v-model="model.email" :placeholder="$translate('username')" required
                                            v-custom-validation="$textRequired()" />
                                    </b-form-group>
                                    <b-form-group class="mb-2">
                                        <b-input-group class="password-field-container">

                                            <b-form-input :type="showPassword ? 'text' : 'password'"
                                                class="form-control form-control-sm" v-model="model.password"
                                                :placeholder="$translate('password')" required
                                                v-custom-validation="$textRequired()" />
                                            <b-input-group-append class="eye-btn">
                                                <i @click="showPassword = !showPassword"
                                                    :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>

                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                    <div class="d-flex justify-content-between">
                                        <b-dropdown variant="light" toggle-class="d-flex align-items-center gap-2"
                                            menu-class="dropdown-menu flag-dropdown navbar-dropdown">
                                            <template #button-content>
                                                <div>
                                                    <span :class="selectedLanguage.flagClass"></span>
                                                    <span>{{ selectedLanguage.label }}</span>
                                                </div>
                                            </template>
                                            <b-dropdown-item v-for="language in languages" :key="language.id"
                                                @click="changeLanguage(language.id)">
                                                <i :class="language.flagClass"></i> {{ language.label }}
                                            </b-dropdown-item>
                                        </b-dropdown>
                                        <div class="align-self-center">
                                            <router-link to="/forgot_password" class="auth-link text-black">
                                                {{ $translate('forgot') }}
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="mb-2 mt-4">
                                        <b-button type="submit" class="btn btn-block btn-facebook auth-form-btn col-12 m-0"
                                            :disabled="signingIn ? true : false">{{
                                                signingIn
                                                ? $translate('signing_in')
                                                : $translate('sign_in')
                                            }}</b-button>
                                    </div>
                                </b-form>
                                <div class="align-self-center">
                                    <div>
                                        <span class="auth-link signup-link">{{ $translate('dont_have_account') }}</span>
                                        <router-link to="/customer-user"
                                            class="auth-link text-primary fw-bolder decoration-off">
                                            {{ $translate('sign_up') }}
                                        </router-link>
                                    </div>
                                </div>
                            </b-col>

                            <div class="col-lg-7 bg-white slider-bar col-md-12 col-sm-12">
                                <Slider />
                            </div>
                        </b-row>
                        <span v-if="termsOfServiceDocumentUrl || privacyPolicyDocumentUrl" cols="12" class="terms-service position-fixed text-center">
                            <span class="m-1">{{ $translate('help') }}</span><span class="ms-1 me-1">.</span>
                            <span v-if="termsOfServiceDocumentUrl" class="m-1"><a :href="termsOfServiceDocumentUrl"
                                    target="_blank">{{ $translate('terms_of_service') }}</a></span>
                            <span class="m-1" v-if="privacyPolicyDocumentUrl"><a :href="privacyPolicyDocumentUrl"
                                    target="_blank">{{ $translate('privacy_policy') }}</a></span>
                        </span>
                    </b-col>
                </b-row>
            </div>
        </b-container>
    </div>
    </b-overlay>
</template>
<script>
import Slider from '@/components/Login/slider.vue'
import layoutMixins from '@/mixins/layoutMixins'
export default {
    name: 'login',
    mixins: [layoutMixins],
    data() {
        return {
            signingIn: false,
            signInError: false,
            model: {
                email: '',
                password: '',
            },
            languages: [
                { id: 'en', label: 'English', flagClass: 'flag-uk' },
                { id: 'es', label: 'Español', flagClass: 'flag-spain' }
            ],
            selectedLanguage: '',
            showPassword: false,
            loading: false,
        }
    },
    components: {
        Slider,
    },
    computed: {
        companySettingData() {
            const data = this.$store.state.company.settings || {}
            console.log("dataaaa", data)
            return data
        },
        companyPolicyKey() {
            return this.$store.state.company.settingKeys.companyPolicyKey
        },
        companyPolicyValue() {
            const companyPolicy = this.$store.getters['company/companyPolicyValue']
            return companyPolicy
        },
        termsOfServiceDocumentUrl() {
            const url = this.companyPolicyValue && this.companyPolicyValue.terms_of_service
            return url
        },
        privacyPolicyDocumentUrl() {
            const url = this.companyPolicyValue && this.companyPolicyValue.privacy_policy
            return url
        },
    },
    created() {
        this.$store.dispatch('company/fetch')
        this.calcPath()
        document.title = 'AMS - Login'
    },
    mounted() {
        if(localStorage.getItem('session_expired')) {
            const error = localStorage.getItem('session_expired')
            this.signInError = this.$translate(error)
        }
    },
    watch: {
        '$i18n.locale': {
            immediate: true,
            handler(val) {
                this.selectedLanguage = this.languages.find(language => language.id === val);
            }
        },
    },
    methods: {
        changeLanguage(obj) {
            if (this.$i18n.locale !== obj) {
                this.$i18n.locale = obj
                localStorage.setItem('language', obj)
                // this.$router.go(0)
            }
        },
        async login(e) {
            e.preventDefault()
            this.signingIn = true
            this.loading = true
            await this.$store
                .dispatch('login', {
                    email: btoa(this.model.email),
                    password: btoa(this.model.password),
                })
                .then(() => {
                    // route to dashboard
                    this.$router.push('dashboard')
                })
                .catch(error => {
                    this.signInError = error.response.data.error.message || error.message
                })
                .finally(() => {
                    this.signingIn = false
                    this.loading = false
                })
        },
        calcPath() {
            let pathSplit = this.$route.path.split('/')
            let group = this.$route.meta.group
            let activeGroup = this.$route.meta.activeGroup
            let displayName = this.$route.meta.displayName
            console.log(this.$route.meta.displayName, 'groupPath')
            pathSplit.splice(0, 1)

            let paths = []
            let runningPath = ''
            for (let segment of pathSplit) {
                runningPath += '/' + segment
                paths.push({
                    displayName,
                    path: runningPath,
                    text: segment,
                    activeGroup,
                    group,
                })
            }
            this.paths = paths
        },
    },
}
</script>
<style scoped>
.eye-btn {
    right: 15px;
    top: 18px;
}
</style>
